import {
  useEffect,
  useState,
  type FunctionComponent,
  type MouseEventHandler,
} from "react";

import { useStakeStore } from "../../state";
import { usePointsStore } from "@stores/points";
import { SocialBar, VersionBadge, StakeStatus } from "@components";
import { Button } from "@bracket/react-button";

import { BracketLogo, NavOpened, NavClosed } from "../../assets";
import { NavMenuItem } from "./NavMenuItem";
import { useEscrowStore } from "../../stores";
import { useMessengerStore } from "@bracket/react-messenger";

import "./NavMenu.scss";
import { useMediaQuery } from "usehooks-ts";
import { useAppKit } from "@reown/appkit/react";
import { useAccount, useChainId } from "wagmi";
import {
  chainInfo,
  formatAddress,
} from "../../components/ConnectionManager/helpers";

export declare type NavMenuProps = {};

export const NavMenu: FunctionComponent<NavMenuProps> = ({}) => {
  const { open } = useAppKit();
  const activeChainId = useChainId();
  const info = chainInfo(activeChainId as any);
  const { address } = useAccount();

  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const isMobile = useMediaQuery("(max-width: 1023px)");

  const { balances } = useEscrowStore();

  const { users_referral_id, safary_referral_id } = usePointsStore();

  const { sendMessage } = useMessengerStore();

  const onLogClick: MouseEventHandler = ({ ctrlKey }) => {
    if (ctrlKey) console.log("balances", balances);
  };

  const onInviteCopy = () => {
    if (users_referral_id) {
      const url = `https://x.bracket.fi/${safary_referral_id}/`;
      navigator.clipboard.writeText(url);
      sendMessage({
        severity: "success",
        title: "Referral code",
        message: "Your referral link is ready to be pasted from the clipboard.",
      });
      return;
    }
    sendMessage({
      severity: "error",
      title: "Referral code",
      message: "failed copying your referral code to the clipboard, try again.",
    });
  };

  const { routes } = useStakeStore();

  if (isMobile) {
    if (!isMobileOpen) {
      return (
        <div className="nav-mobile-top">
          <BracketLogo />
          <div>
            {address && (
              <div
                className="chain-btn"
                onClick={() => open({ view: "Account" })}
              >
                <div
                  className="chain-btn-icon"
                  style={{ backgroundImage: `url(${info.icon})` }}
                />
                <div className="chain-btn-address">
                  {formatAddress(address)}
                </div>
              </div>
            )}
          </div>
          <NavOpened onClick={() => setIsMobileOpen(true)} />
        </div>
      );
    }
    return (
      isMobileOpen && (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <>
          <div className="nav-mobile-top">
            <BracketLogo />
            <div>
              {address && (
                <div
                  className="chain-btn"
                  onClick={() => open({ view: "Account" })}
                >
                  <div
                    className="chain-btn-icon"
                    style={{ backgroundImage: `url(${info.icon})` }}
                  />
                  <div className="chain-btn-address">
                    {formatAddress(address)}
                  </div>
                </div>
              )}
            </div>
            <NavClosed onClick={() => setIsMobileOpen(false)} />
          </div>
          <div className="nav-menu-mobile">
            <div className="nav-menu-wrapper">
              <section
                className="section items"
                onClick={() => setIsMobileOpen(!isMobileOpen)}
              >
                {routes
                  .filter((r) =>
                    ["Stake", "Bars", "Analytics"].includes(r.name)
                  )
                  .map((route, k) =>
                    route.name === "default" ? null : (
                      <NavMenuItem key={k} {...route} />
                    )
                  )}
              </section>
              <section className="stake-card-container">
                <StakeStatus />
                {/* <Button
              label="Refer for a 20% boost"
              variant="primary-outline"
              icon="Copy"
              iconPosition="end"
              onClick={onInviteCopy}
              className="refer"
            /> */}
                <SocialBar />
                {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                <div
                  className="zellic"
                  onClick={(evt) =>
                    window.open(
                      "https://bracket-labs.gitbook.io/bracket/security/audits",
                      "_blank"
                    )
                  }
                >
                  <div className="label">
                    <p>Audited by</p>
                  </div>
                  <div className="logo" />
                </div>
              </section>
            </div>
          </div>
        </>
      )
    );
  }

  return (
    <div className="nav-menu">
      <div className="content">
        <section className="section title" onClick={onLogClick}>
          <BracketLogo />
        </section>
        <section className="section items">
          {routes.map((route, k) =>
            route.name === "default" ? null : <NavMenuItem key={k} {...route} />
          )}
        </section>
        <section className="lower">
          <StakeStatus />
          <Button
            label="Refer for a 20% boost"
            variant="primary-outline"
            icon="Copy"
            iconPosition="end"
            onClick={onInviteCopy}
            className="refer"
          />
          <SocialBar />
          <div
            className="zellic"
            onClick={(evt) =>
              window.open(
                "https://bracket-labs.gitbook.io/bracket/security/audits",
                "_blank"
              )
            }
          >
            <div className="label">
              <p>Audited by</p>
            </div>
            <div className="logo" />
          </div>
          <VersionBadge />
        </section>
      </div>
    </div>
  );
};
